import {
  Box,
  HStack,
  Popover,
  PopoverContent,
  PopoverProps,
  PopoverTrigger,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { CurrentActiveUserInterface } from "../../constants/User";
import { useGetUserLoginStore } from "../../store/useGetUserLoginStore";
import {
  useBgHover,
  useDarkWhiteColor,
  useDividerColor,
} from "../../themes/colors";
import { goToDashboard } from "../../utils/helperFunction";
import { ButtonLogout } from "../button/ButtonLogout";
import { LoginText } from "../button/LoginText";
import { UserHeaderCard } from "./UserHeaderCard";
import { UserNonActiveCard } from "./UserNonActiveCard";

interface Props extends PopoverProps {}

export const PopoverHeaderSwitchAccount = ({ ...rest }: Props) => {
  const dividerColor = useDividerColor();
  const bgHover = useBgHover();
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { loggedUsers } = useGetUserLoginStore();
  const { currentActiveUser } = useGetUserLoginStore();
  const bgBnw = useDarkWhiteColor();

  const allRoles = ["buyer", "reseller", "supplier"];

  const loginSuggestedRoles = allRoles
    .filter((role: string) => currentActiveUser?.role !== role)
    .map((role) => {
      const user = (loggedUsers as CurrentActiveUserInterface[])?.find(
        (u: any) => u.role === role
      );

      if (user) {
        return {
          id: user?.id,
          role: user?.role,
          name: user?.name,
          image: user?.image,
          fcm_token: user?.fcm_token,
        };
      } else {
        return {
          role,
        };
      }
    });

  return (
    <Popover
      trigger="hover"
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      {...rest}
    >
      <PopoverTrigger>
        <Box>
          <UserHeaderCard />
        </Box>
      </PopoverTrigger>

      {isOpen && (
        <PopoverContent
          rounded={0}
          border={"none"}
          w={"auto"}
          shadow={"none"}
          bg={"transparent"}
        >
          <Box
            w={"240px"}
            roundedBottom={2}
            maxH={"80vh"}
            overflowY={"auto"}
            bg={bgBnw}
            mr={{ base: 0, md: 2, xl: 0 }}
            shadow={"md"}
            borderBottomRadius={["md", null, "lg"]}
          >
            <Box
              px={5}
              py={2}
              borderBottomWidth={"1px"}
              borderColor={dividerColor}
            >
              <Text
                textStyle={"b-sm"}
                fontWeight={"semibold"}
                variant={"secondary"}
                mb={"4px"}
              >
                Menu
              </Text>

              <HStack
                w={"100%"}
                p={1}
                borderRadius={"md"}
                cursor={"pointer"}
                onClick={() => goToDashboard(navigate)}
                _hover={{ bg: bgHover }}
              >
                <Text display={"block"} textStyle={"b-sm-sb"} fontWeight={500}>
                  Dashboard
                </Text>
              </HStack>
            </Box>

            <Box
              px={5}
              py={2}
              borderBottomWidth={"1px"}
              borderColor={dividerColor}
            >
              <Text
                textStyle={"b-sm"}
                fontWeight={"semibold"}
                variant={"secondary"}
                mb={"4px"}
              >
                Akun
              </Text>

              {loginSuggestedRoles?.map((user, index) => (
                <Box key={index}>
                  {user?.id ? (
                    <UserNonActiveCard user={user} />
                  ) : (
                    <LoginText user={user} />
                  )}
                </Box>
              ))}
            </Box>

            <VStack align={"stretch"} gap={1}>
              <ButtonLogout
                user={currentActiveUser}
                logoutAllUser={false}
                px={6}
                py={2}
                mt={1}
              />
              <ButtonLogout
                user={currentActiveUser}
                logoutAllUser={true}
                px={6}
                py={2}
                mt={1}
              />
            </VStack>
          </Box>
        </PopoverContent>
      )}
    </Popover>
  );
};
